// make sure that links inside the usp are link to igus.xxx where xxx is determined by the current locale.
import { IGUS_REWRITE } from '@hub/libs/redirect.helper';

export const fixMarkupLinks = (val: string, locale: string | undefined) => {
  let value = val;
  // find a href attributes
  const result = value.match(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/);
  if (result && result.length === 3) {
    let target = result[2];

    // sometimes the link contains an akeneo path, should be fix with COM-426
    const akeneoPrefix = 'https://igus-production.cloud.akeneo.com';
    if (target.startsWith(akeneoPrefix)) {
      target = target.replace(akeneoPrefix, '');
      value = val.replace(akeneoPrefix, '');
    }

    // just handle paths. If it is a complete uri, don't touch it
    if (target.startsWith('/')) {
      return value.replace(target, IGUS_REWRITE(target, locale));
    }
  }
  return value;
};

// TODO we should think about replacing it with a more robust/existing solution
export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(/®/g, '')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');

export const isValidLink = (url: string): boolean => {
  const link = url.trim();
  return link.startsWith('/') || link.startsWith('http');
};
